
var av = Autodesk.Viewing;
var avu = Autodesk.Viewing.UI;


export var ListPanelEvents = {

    /**
     * Fired when clicking on an item. (not fired when setting current item per code)
     *  @property {Object} item  - data item being selected.
     */
    ITEM_SELECT: 'itemSelect',

    /*
     * Fired when toggling item visibility
     *  @property {Object} item    - data item
     *  @property {bool}   visible - whether item was toggled on or off
     */
    ITEM_VISIBILITY_CHANGED: 'itemVisibibilityChanged',

    /**
     * @property {Object} item - data item being selected.
     */
    ITEM_MOUSE_ENTER: 'itemMouseEnter',
    ITEM_MOUSE_LEAVE: 'itemMouseLeave'
};

export class ListPanel extends avu.DockingPanel {
    constructor(parentContainer, id, title, options) {
        super(parentContainer, id, title, options);

        av.EventDispatcher.prototype.apply(this);

        this.container.classList.add('list-panel');
        this.container.dockRight = true;
        this.createScrollContainer({left: false, heightAdjustment: 65, marginTop:0});
    }

    // @param {Object[]} items - Array order defines display order top-down.
    setItems(items) {

        this.buttons = [];
        this.items   = items;

        // remove old list
        if (this.listDiv) {
            this.scrollContainer.removeChild(this.listDiv);
        }
        var _document = this.getDocument();
        this.listDiv = _document.createElement('div');
        this.listDiv.classList.add('itemList');

        this.scrollContainer.appendChild(this.listDiv);

        var scope = this;

        var createButton = function(item) {

            var itemText = scope._getItemText ? scope._getItemText(item) : '<no item text>';

            var button = _document.createElement('div');
            button.classList.add('listItem');
            button.item = item;
            button.setAttribute('title', itemText);

            button.addEventListener('click', function() {
                scope.fireEvent({
                    type: ListPanelEvents.ITEM_SELECT,
                    item: item
                });
            });
            button.addEventListener('mouseenter', function() {
                scope.fireEvent({
                    type: ListPanelEvents.ITEM_MOUSE_ENTER,
                    item: item
                });
                button.classList.add('hover');
            });
            button.addEventListener('mouseleave', function() {
                scope.fireEvent({
                    type: ListPanelEvents.ITEM_MOUSE_LEAVE,
                    item: item
                });
                button.classList.remove('hover');
            });

            var textSpan = _document.createElement('span');
            textSpan.textContent = itemText;
            textSpan.classList.add("text");

            // This container DIV is required to enable proper text fade-out for long texts.
            var textContainerDiv = _document.createElement('div');
            textContainerDiv.classList.add("textContainer");
            textContainerDiv.appendChild(textSpan);
            button.appendChild(textContainerDiv);

            // Optional: Enable warning symbol per item
            if (scope.options.enableWarningSymbol) {
                var warnSpan = _document.createElement('span');
                warnSpan.classList.add("list-panel-item-warning");
                button.appendChild(warnSpan);
                button.warnSpan = warnSpan;
            }

            // Optional: Show checkmark for selected items
            if (scope.options.enableCheckmark) {
                var checkSpan = _document.createElement('span');
                checkSpan.classList.add("icon");
                button.appendChild(checkSpan);
            }

            // Optional: Show eye-symbol
            if (scope.options.enableVisibilityToggle) {
                var eyeSymbol = _document.createElement('div');
                eyeSymbol.classList.add("visibility");
                button.appendChild(eyeSymbol);

                eyeSymbol.addEventListener('click', function() {
                    const wasVisible = scope._isVisible ? scope._isVisible(button.item) : true;
                    scope.fireEvent({
                        type: ListPanelEvents.ITEM_VISIBILITY_CHANGED,
                        item: button.item,
                        visible: !wasVisible
                    });
                    scope.updateItemStates();
                });
            }

            return button;
        };

        for (var index=0; index<items.length; index++) {

            var item   = items[index];
            var button = createButton(item);

            this.listDiv.appendChild(button);
            this.buttons.push(button);
        }

        this.updateItemStates();
    }

    // Trigger mouse-over highlighting on item.
    //  @param {function} filter - gets an item
    rollOverItem(filter) {
        for (var i=0; i<this.buttons.length; i++) {
            var button = this.buttons[i];
            if (filter(button.item)) {
                button.classList.add('hover');
            } else {
                button.classList.remove('hover');
            }
        }
    }

    updateItemStates() {

        if (!this.buttons) {
            return;
        }
        for (var i=0; i<this.buttons.length; i++) {

            // set/unset blue color for selected items and show optional checkmark
            var button = this.buttons[i];
            button.classList.remove("selected");
            if (this._isSelected && this._isSelected(button.item)) {
                button.classList.add("selected");
            }

            // set/unset warning symbol
            if (this.options.enableWarningSymbol) {
                var warnText = this._getWarningText && this._getWarningText(button.item);
                button.warnSpan.style.visibility = warnText ? 'visible' : 'hidden';
                button.warnSpan.setAttribute('title', warnText || '');
            }

            // set state of visibility toggle (eye symbol)
            if (this.options.enableVisibilityToggle) {
                button.classList.remove("dim");
                var isVisible = this._isVisible ? this._isVisible(button.item) : true;
                if (!isVisible) {
                    button.classList.add('dim');
                }
            }
        }
    }

    // Set functions to define how to handle each item
    //  @param {function(item)} isSelected       - takes a list item (see setItems) and returns true for 'selected state'
    //  @param {function(item)} getItemText      - returns the text to be displayed
    //  @param {function(item)} [getWarningText] - Optional: Display a warning symbol. Function defines tooltip text.
    //  @param {function(item)} [isVisible]      - Optional: State of visibility toggle. If set, an additional eye-symbol is shown to toggle visibility per item.
    setItemHandlers(isSelected, getItemText, getWarningText, isVisible) {
        this._isSelected  = isSelected;
        this._getItemText = getItemText;
        this._getWarningText = getWarningText;
        this._isVisible = isVisible;
        this.updateItemStates();
    }
}


avu.ListPanelEvents = ListPanelEvents;
avu.ListPanel       = ListPanel;
